import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiClock, FiRefreshCw, FiArrowRight, FiCheck } = FiIcons;

const plans = [
  {
    icon: FiClock,
    title: "Weekly Subscription Plan",
    price: "$115",
    desc: "Per service"
  },
  {
    icon: FiRefreshCw,
    title: "Bi-Weekly Subscription Plan",
    price: "$125",
    desc: "Per service"
  },
  {
    icon: FiCalendar,
    title: "Monthly Subscription Plan",
    price: "$150",
    desc: "Per service"
  }
];

export default function MaintenanceSection() {
  return (
    <section className="py-24 bg-slate-900 border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-blue-500 font-bold tracking-widest uppercase text-xs mb-3 block">
              Ongoing Care
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-white uppercase tracking-tight mb-6">
              Maintenance Plans
            </h2>
            <div className="w-12 h-1 bg-blue-600 mb-6" />
            <p className="text-slate-300 text-lg mb-8 leading-relaxed">
              A flawless finish shouldn't just last a few weeks. Once your vehicle has received a <strong className="text-white">full detail</strong> to establish a perfect baseline, you can choose a maintenance plan to keep it looking fresh year-round.
            </p>
            
            <ul className="space-y-4 mb-10">
              <li className="flex items-start gap-3 text-slate-300 text-sm">
                <FiCheck className="text-blue-500 mt-0.5 flex-shrink-0 text-base" />
                <span>Available exclusively after a <strong>full detail</strong> is completed.</span>
              </li>
              <li className="flex items-start gap-3 text-slate-300 text-sm">
                <FiCheck className="text-blue-500 mt-0.5 flex-shrink-0 text-base" />
                <span><strong>All interior services</strong> are included in every plan.</span>
              </li>
              <li className="flex items-start gap-3 text-slate-300 text-sm">
                <FiCheck className="text-blue-500 mt-0.5 flex-shrink-0 text-base" />
                <span>Total flexibility. <strong>Cancel or pause</strong> at your convenience.</span>
              </li>
            </ul>
            
            <Link 
              to="/contact" 
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 border-2 border-slate-700 text-white font-bold rounded-sm hover:border-blue-500 hover:text-blue-400 transition-all uppercase tracking-wide text-sm"
            >
              Ask About Maintenance <FiArrowRight />
            </Link>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex flex-col gap-4"
          >
            {plans.map((p, i) => (
              <div key={i} className="flex items-center justify-between bg-slate-950 border border-slate-800 p-6 rounded-sm hover:border-blue-500/30 transition-colors group">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-blue-600/10 border border-blue-500/20 rounded-sm flex items-center justify-center flex-shrink-0 group-hover:bg-blue-600/20 transition-colors">
                    <p.icon className="text-blue-500 text-xl" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold text-sm uppercase tracking-wide mb-1">{p.title}</h4>
                    <p className="text-slate-500 text-xs font-semibold uppercase tracking-wider">{p.desc}</p>
                  </div>
                </div>
                <div className="text-right pl-4">
                  <div className="text-2xl md:text-3xl font-black text-white">{p.price}</div>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}